import * as React from "react";
import { ModalWrap } from "./styles";
class MobileModal extends React.PureComponent {
    render() {
        const { visible } = this.props;
        return (React.createElement(ModalWrap, { style: { display: visible ? "flex" : "none" } }, this.props.children));
    }
}
export default MobileModal;
